import { Box, Flex, HStack } from "@chakra-ui/react";
import { StaffRoutes } from "appRoutePaths";
import { Navigate } from "components/Navigate";
import { Footer } from "components/Navigation/Footer";
import { NavHeader } from "components/Navigation/NavHeader";
import { SideMenu } from "components/Navigation/SideMenu/SideMenu";
import { StaffMenuItems } from "components/Navigation/SideMenu/sideMenuEntries";
import { Roles } from "context/auth";
import { FC, PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";
import useIdentityRedirection, { getUserDashboardUrl } from "./useIdentityRedirection";

const StaffLayout: FC<PropsWithChildren & { showSideMenu: boolean }> = ({ children, showSideMenu }) => {
    const { shouldRedirect, destination, roles } = useIdentityRedirection([Roles.Staff, Roles.SeniorStaff, Roles.Admin]);

    if (shouldRedirect) {
        return <Navigate to={destination!} replace />;
    }

    const menuItems = StaffMenuItems(roles);
    const validPaths = menuItems.map(m => m.url.toLowerCase());
    const currentPath = window.location.pathname.toLowerCase();

    if (roles.includes(Roles.Admin) || roles.includes(Roles.SeniorStaff)) {
        validPaths.push(StaffRoutes.auditLog.url);
    }
    if (roles.includes(Roles.Admin)) {
        validPaths.push(StaffRoutes.shipmentMetrics.url);
    }

    if (!validPaths.find(p => currentPath.startsWith(p))) {
        // redirect to the dashboard if the user tries to hit a page that's not in
        // their navigation list. yeah, it's not ideal, but beats page-by-page checks.
        const dashboardUrl = getUserDashboardUrl(roles);
        return <Navigate to={dashboardUrl} replace />;
    }

    return (
        <Flex
            flexDir="column"
            minH="100vh"
            w="100%"
            justifyContent="space-between"
        >
            <NavHeader />
            <HStack align="start" flex={1} gap={0}>
                {showSideMenu && <SideMenu entries={menuItems} />}
                <Box flex={1} style={{ marginLeft: '0px', alignSelf: 'stretch' }}>{children ? children : <Outlet />}</Box>
            </HStack>
            <Footer />
        </Flex>
    );
};

export default StaffLayout;
